import { atom } from "jotai";

import { Permission } from "@shared/types";

/**
 * Permissions Atom - permissions are loaded and set in the ChangeOrg atom
 */
export const permissionsAtom = atom<Permission[]>([]);
